import type { TFunction } from "i18next";
import type { ValueKind } from "@/components/auditLog/auditLogTypes";
import { auditDateLabel } from "@/components/auditLog/auditDateLabel";

interface ValueLabelOptions {
  fieldName?: string;
  literal?: boolean;
}

export function auditValueLabel(
  kind: ValueKind,
  text: string,
  t: TFunction,
  { fieldName = "", literal = false }: ValueLabelOptions = {}
): string {
  if (kind === "null") return t("audit_diff_not_set");
  if (kind === "boolean") return t(text === "true" ? "yes" : "no");
  if (kind === "string" && text === "") return t("audit_diff_empty_text");
  if (kind === "string" && !literal) {
    const date = auditDateLabel(text);
    if (date !== null) return date;
    if (
      (fieldName === "status" || fieldName.endsWith("_status")) &&
      /^[a-z][a-z0-9_]*$/.test(text)
    )
      return t(`status_${text}`, { defaultValue: text });
  }
  return text;
}
